import React, { FC, memo, useCallback, useState } from 'react'

import { FilterItemTransport, FilterTransport } from '../../../../../transports/filters-configuration-transport'
import { FilterHeadPosition, FilterType } from '../../types'
import RadioFilterItem from './radio-filter-item'

type Props = {
    filter: FilterTransport
    filterHeadPosition: FilterHeadPosition
}

const RadioFilter: FC<Props> = ({ filter, filterHeadPosition }) => {
    const [selectedFilterItemPosition, setSelectedFilterItemPosition] = useState<number>(() => {
        return filter.items.findIndex(item => item.checked)
    })

    const handleFilterItemClick = useCallback((filterItemPosition: number) => {
        setSelectedFilterItemPosition(filterItemPosition)
    }, [])

    return (
        <>
            {filter.items.map((filterItem: FilterItemTransport, index) => {
                return (
                    <RadioFilterItem
                        filterItem={filterItem}
                        filterType={filter.type}
                        key={filterItem.title}
                        filterItemPosition={index}
                        isFilterItemSelected={index === selectedFilterItemPosition}
                        onFilterItemClick={handleFilterItemClick}
                        shouldCommit={filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_LISTING}
                    />
                )
            })}
        </>
    )
}

export default memo(RadioFilter)
